export default __webpack_public_path__ + "static/media/grade_3_16_1@2x.12bbc67c.png";